<template>
  <div>
    <el-form
      role="form"
      class=""
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
    >
      <div class="relative mb-4">
        <small class="fsize12 bg-white font-medium text-dark"
          >Product Name</small
        >
        <el-input
          placeholder="Enter or Type..."
          v-model="productName"
          class="rounded-xl mt-2"
          disabled
        />
      </div>
      <div>
        <small class="fsize12 font-semibold bg-white text-dark">{{
          attributeName
        }}</small>
        <div class="mt-1 flex gap-2">
          <el-input
            placeholder="Enter or Type..."
            v-model="attributeVal"
            class="rounded-xl mt-2"
            disabled
          />
          <!-- <el-select
          multiple
          filterable
          default-first-option
          v-model="attributeVal"
          placeholder="Enter or Type..."
          class="w-full mt-2"
        >
          <el-option
            v-for="(att, index) in productImageId"
            :key="`${att.valueName} + ${index}`"
            :label="att.valueName"
            :value="att.valueName"
          >
          </el-option>
        </el-select> -->
        </div>
      </div>
      <div class="mt-4 flex gap-2 flex-wrap" v-if="varientSKU !== ''">
        <!-- <el-tag class="light-purplebgtext border-none skutag">{{
          varientSKU
        }}</el-tag> -->
        <img id="SKUBarcode" :alt="varientSKU" class="w-full mt-4" />
      </div>
      <div class="mt-4">
        <small class="fsize12 font-semibold bg-white text-dark">{{
          varientName
        }}</small>
        <div class="mt-1 flex gap-2">
          <el-input
            placeholder="Enter or Type Variation Value..."
            v-model="varientVal"
            class="rounded-xl mt-2"
            disabled
          />
        </div>
      </div>

      <div class="mt-4">
        <div class="flex items-center justify-between">
          <small class="fsize12 font-semibold bg-white text-dark">Stock</small>
          <div class="flex gap-2">
            <el-tag class="light-purplebgtext border-none skutag"
              >Total:{{ stockTotal }}</el-tag
            >

            <el-tag class="light-purplebgtext border-none skutag"
              >Left:{{ stockLeft }}</el-tag
            >
          </div>
        </div>
        <div class="mt-2 flex gap-2">
          <el-form-item class="w-full" prop="addStock">
            <el-input
              placeholder="Enter or Type Stock Value..."
              v-model="ruleForm.addStock"
              class="rounded-xl mt-2"
            />
          </el-form-item>
        </div>
      </div>

      <div class="flex items-center gap-6 grid-cols-2">
        <div class="w-full">
          <small class="fsize12 font-semibold bg-white text-dark">Price</small>
          <div class="mt-1 flex gap-2">
            <el-form-item class="w-full" prop="varientPrice">
              <el-input
                placeholder="Enter or Type Price..."
                v-model="ruleForm.varientPrice"
                class="rounded-xl mt-2"
              />
            </el-form-item>
          </div>
        </div>

        <div class="w-full">
          <small class="fsize12 font-semibold bg-white text-dark"
            >Discount</small
          >
          <el-form-item class="w-full" prop="varientDiscount">
            <el-input
              placeholder="Enter %..."
              v-model="ruleForm.varientDiscount"
              @input="calDiscountedPrice"
              class="rounded-xl mt-2"
              :maxlength="2"
            />
          </el-form-item>
        </div>
      </div>
      <div
        class="flex gap-2 flex-wrap justify-between"
        v-if="ruleForm.varientDiscount"
      >
        <div v-if="ruleForm.varientDiscount">
          <small class="fsize12 font-semibold bg-white text-dark"
            >Price after Discount
          </small>
          <el-tag class="light-purplebgtext border-none skutag">{{
            varientDiscountedPrice
          }}</el-tag>
        </div>
        <div>
          <feather-icon
            icon="TrashIcon"
            class="cursor-pointer"
            svgClasses="w-5 h-5"
            @click="deletePopup(variationId)"
          />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-4 mt-8">
        <vs-button
          type="primary"
          class="bg-primary rounded-lg font-semibold py-4 fsize14"
          @click="handleSubmit('ruleForm')"
          >Save</vs-button
        >

        <vs-button
          type="secondary"
          @click="closePopup"
          class="bg-secondary rounded-lg font-semibold py-4 fsize14"
          >Cancel</vs-button
        >
      </div>
    </el-form>
  </div>
</template>
<script>
const JsBarcode = require("jsbarcode");
export default {
  props: {
    productDetail: {
      Type: Object,
    },
    EditAttribuitesShow: {
      Type: Boolean,
    },
  },
  data() {
    return {
      productName: "",
      attributeName: "",
      varientName: "",
      variationId: "",
      attributeVal: "",
      varientVal: "",
      // varientPrice: "",
      varientSKU: "",
      // varientDiscount: "",
      varientDiscountedPrice: "",
      productImageId: [],
      stockTotal: 0,
      stockLeft: 0,
      // addStock: 0,
      ruleForm: {
        varientPrice: "",
        varientDiscount: "",
        addStock: "",
      },
      rules: {
        varientPrice: [
          {
            required: true,
            message: "Please Enter Price",
            trigger: "blur",
          },
          {
            pattern: /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/,
            message: "Price must be Positive number",
            trigger: "blur",
          },
        ],
        varientDiscount: [
          // {
          //   // required: true,
          //   message: "Please Enter Discount ",
          //   trigger: "blur",
          // },
          {
            pattern: /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/,
            message: "Discount must be Positive number",
            trigger: "blur",
          },
        ],
        addStock: [
          {
            message: "Please Enter Stock Amount",
            trigger: "blur",
          },
          {
            pattern: /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/,
            message: "Stock must be Positive number",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    async EditAttribuitesShow(val) {
      if (val === true) {
        this.resetForm("ruleForm");
        await this.init();
        JsBarcode("#SKUBarcode", this.varientSKU);
      } else {
        this.resetData();
      }
    },
    "ruleForm.varientPrice"() {
      this.calDiscountedPrice();
    },
    "ruleForm.varientDiscount"() {
      this.calDiscountedPrice();
    },
  },
  methods: {
    // createSKU() {
    //   this.varientSKU = [];
    //   if (this.varientVal !== "" && this.attributeVal !== "") {
    //     let productNameSKU = this.productDetail.productName
    //       .toUpperCase()
    //       .slice(0, 3);
    //     let productNameLength = this.productDetail.productName.length;
    //     let productVarientVal = this.varientVal.toUpperCase().slice(0, 3);
    //     let productId = this.productDetail._id.toUpperCase().slice(-5);
    //     for (let data of this.attributeVal) {
    //       let productAttributeVal = data.toUpperCase().slice(0, 3);
    //       this.varientSKU.push({
    //         SKU: `${productNameSKU}-${productAttributeVal}-${productVarientVal}-${productId}`,
    //         attributeVal: data,
    //         productImageId: this.productDetail.productImageId.filter((x) => {
    //           if (x.valueName == data) {
    //             return x._id;
    //           }
    //         }),
    //       });
    //       // console.log(this.varientSKU);
    //     }
    //   }
    // },
    handleSubmit(formName) {
      // this.ruleForm.addStock = this.ruleForm.addStock.trim();
      // this.ruleForm.varientPrice = this.ruleForm.varientPrice.trim();
      // this.ruleForm.varientDiscount = this.ruleForm.varientDiscount.trim();

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.UpdateVariation();
        } else {
          // this.formfield();
          return false;
        }
      });
    },
    resetForm(formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
      }
      this.ruleForm.varientPrice = "";
      this.ruleForm.varientDiscount = "";
      this.ruleForm.addStock = "";
    },
    async deletePopup(id) {
      this.$swal({
        title: "Are you sure?",
        type: "Warning",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#cd3197",
        confirmButtonText: "Yes, Delete it",
        cancelButtonText: "No, keep it",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.handleDelete(id);
        }
      });
    },
    async handleDelete(id) {
      let payload = {
        id: id,
        // adminId: this.login._id,
      };
      try {
        let data = await this.$store.dispatch(
          "EcomVariation/deleteVariation",
          payload
        );
        if (data.code === 200) {
          await this.$store.dispatch("EcomProduct/getAllProduct");
          this.closePopup();
          await this.$swal("Deleted", "Successfully deleted", "success");
          this.resetData();
        }
      } catch (error) {
        console.log(error);
        await this.$swal("Delete", "Failed to Delete", "error");
      }
    },
    async UpdateVariation() {
      // console.log(this.productDetail);
      // console.log(this.varientSKU);
      const payload = { id: this.variationId };

      if (this.ruleForm.addStock)
        Object.assign(payload, { stock: parseInt(this.ruleForm.addStock) });
      if (this.ruleForm.varientDiscount)
        Object.assign(payload, {
          discountPercentage: this.ruleForm.varientDiscount,
        });
      if (this.varientDiscountedPrice)
        Object.assign(payload, {
          discountedPrice: this.varientDiscountedPrice,
        });
      if (this.ruleForm.varientPrice)
        Object.assign(payload, { actualPrice: this.ruleForm.varientPrice });
      let loader;
      try {
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let data = await this.$store.dispatch(
          "EcomVariation/updateVariation",
          payload
        );
        if (data.code === 200) {
          await this.$store.dispatch("EcomProduct/getAllProduct");
          loader.close();
          this.closePopup();
          await this.$swal({
            title: `Product Variation Updated Successfully!`,
            type: "success",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
          this.resetData();
        }
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
        await this.$swal({
          title: `Failed to Update the Product Variation!`,
          type: "error",
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
      }
    },
    closePopup() {
      this.ruleForm.addStock = "";
      this.$emit("closePopup");
    },
    resetData() {
      this.attributeVal = "";
      this.varientVal = "";
      this.ruleForm.varientPrice = "";
      this.varientSKU = "";
      this.ruleForm.varientDiscount = "";
      this.varientDiscountedPrice = "";
      this.productName = "";
      this.attributeName = "";
      this.varientName = "";
      this.variationId = "";
      this.productImageId = [];
      this.ruleForm.addStock = "";
      this.stockTotal = 0;
      this.stockLeft = 0;
    },
    calDiscountedPrice() {
      let discount =
        (this.ruleForm.varientPrice / 100) * this.ruleForm.varientDiscount;
      // console.log(discount);
      this.varientDiscountedPrice = this.ruleForm.varientPrice - discount;
    },
    async init() {
      try {
        this.variationId = this.productDetail._id;
        let data = await this.$store.dispatch("EcomVariation/getVariation", {
          variationId: this.variationId,
        });
        if (data.code === 200) {
          // console.log("EditAttribuites", data);
          this.attributeName = data.data[0].productId[0].attributesId[0].name
            ? data.data[0].productId[0].attributesId[0].name
            : this.attributeName;
          this.productName = data.data[0].productId[0].productName
            ? data.data[0].productId[0].productName
            : this.productName;
          this.attributeVal = data.data[0].attributeValueName
            ? data.data[0].attributeValueName
            : this.attributeVal;
          this.varientName = data.data[0].name
            ? data.data[0].name
            : this.varientName;
          this.varientVal = data.data[0].variationValueName
            ? data.data[0].variationValueName
            : this.varientVal;
          this.ruleForm.varientPrice = data.data[0].actualPrice
            ? data.data[0].actualPrice
            : this.varientPrice;
          this.varientSKU = data.data[0].SKU
            ? data.data[0].SKU
            : this.varientSKU;
          this.ruleForm.varientDiscount = data.data[0].discountPercentage
            ? data.data[0].discountPercentage
            : this.varientDiscount;
          this.varientDiscountedPrice = data.data[0].discountedPrice
            ? data.data[0].discountedPrice
            : this.varientDiscountedPrice;
          this.productImageId = data.data[0].productId[0].productImageId
            ? data.data[0].productId[0].productImageId
            : this.productImageId;
          this.stockLeft = data.data[0].stockLeft ? data.data[0].stockLeft : 0;
          this.stockTotal = data.data[0].stockTotal
            ? data.data[0].stockTotal
            : 0;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    await this.init();
    JsBarcode("#SKUBarcode", this.varientSKU);
  },
};
</script>
